import React from "react";
import "../../styles/Accordion.css";
import AllertIscrizione from "../multitessere/AllertIscrizione";
import AllertCertificato from "../multitessere/AllertCertificato";

function NLAccordionOrari() {
    return (
        <div
            className="accordion d-flex flex-column m-auto"
            id="accordionFlushOrari"
            style={{ maxWidth: "55em" }} // puoi regolare la larghezza max
        >
            <div className="accordion-item">
                <h2
                    className="accordion-header d-flex flex-row"
                    id="headingPrezzi"
                    style={{ justifyContent: "center", textAlign: "center" }}
                >
                    <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapsePrezzi"
                        aria-expanded="false"
                        aria-controls="collapsePrezzi"
                    >
                        ORARI SENZA CORSI
                    </button>
                </h2>
                <div
                    id="collapsePrezzi"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingPrezzi"
                    data-bs-parent="#accordionFlushOrari"
                >
                    <div className="accordion-body">
                        <div
                            className="table-container"
                            style={{
                                overflowX: "auto",
                            }}
                        >
                            <h4 className="d-flex flex-row" style={{justifyContent: "center", textAlign: "center"}}>VASCA PRINCIPALE</h4>
                            <p style={{ textAlign: "center" }}>
                                Durante gli orari indicati <strong>tutte le corsie</strong> della vasca principale sono disponibili per il nuoto libero.
                                <br />
                                Negli altri orari è comunque garantita <strong>almeno una corsia</strong>.
                            </p>

                            <table
                                className="table text-center m-auto"
                                style={{
                                    width: "100%",
                                    tableLayout: "fixed",
                                    minWidth: "600px",
                                }}
                            >
                            <thead>
                                <tr>
                                    <th scope="col">Lun</th>
                                    <th scope="col">Mar</th>
                                    <th scope="col">Mer</th>
                                    <th scope="col">Gio</th>
                                    <th scope="col">Ven</th>
                                    <th scope="col">Sab</th>
                                    <th scope="col">Dom</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td className="data-cell">7 - 9.15</td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell">7 - 12.30</td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell">7 - 9.15</td>
                                    <td className="data-cell">9.15 - 10.15</td>
                                    <td className="data-cell">9 - 13</td>
                                </tr>
                                <tr>
                                    <td className="data-cell">10.45 - 13.00</td>
                                    <td className="data-cell">11.30 - 12.45</td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell">10.45 - 13.00</td>
                                    <td className="data-cell">11.30 - 12.45</td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell"></td>
                                </tr>
                                <tr>
                                    <td className="data-cell">14.15 - 16</td>
                                    <td className="data-cell">13.30 - 16</td>
                                    <td className="data-cell">14.30 - 17</td>
                                    <td className="data-cell">14.15 - 16</td>
                                    <td className="data-cell">13.30 - 16.15</td>
                                    <td className="data-cell">17 - 19</td>
                                    <td className="data-cell"></td>
                                </tr>
                                <tr>
                                    <td className="data-cell">20.45 - 22</td>
                                    <td className="data-cell">20.45 - 22</td>
                                    <td className="data-cell">20.45 - 22</td>
                                    <td className="data-cell">20.45 - 22</td>
                                    <td className="data-cell">20.45 - 22</td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell"></td>
                                </tr>
                                </tbody>
                            </table>
                            <hr/>
                            <h4 className="d-flex flex-row" style={{justifyContent: "center", textAlign: "center"}}>VASCA DIDATTICA</h4>

                            <table
                                className="table text-center m-auto"
                                style={{
                                    width: "100%",
                                    tableLayout: "fixed",
                                    minWidth: "600px",
                                }}
                            >
                                <thead>
                                <tr>
                                    <th scope="col">Lun</th>
                                    <th scope="col">Mar</th>
                                    <th scope="col">Mer</th>
                                    <th scope="col">Gio</th>
                                    <th scope="col">Ven</th>
                                    <th scope="col">Sab</th>
                                    <th scope="col">Dom</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td className="data-cell">7 - 9.15</td>
                                    <td className="data-cell">9 - 9.15</td>
                                    <td className="data-cell">7 - 9.15</td>
                                    <td className="data-cell">9 - 9.15</td>
                                    <td className="data-cell">7 - 9.15</td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell"></td>
                                </tr>
                                <tr>
                                    <td className="data-cell">10.45 - 12.40</td>
                                    <td className="data-cell">11.30 - 12.45</td>
                                    <td className="data-cell">10 - 10.45</td>
                                    <td className="data-cell">10.45 - 12.40</td>
                                    <td className="data-cell">11.30 - 12.45</td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell"></td>
                                </tr>
                                <tr>
                                    <td className="data-cell">14.15 - 16.15</td>
                                    <td className="data-cell">13.30 - 16.15</td>
                                    <td className="data-cell">14 - 17</td>
                                    <td className="data-cell">14.15 - 16.15</td>
                                    <td className="data-cell">13.30 - 14.30</td>
                                    <td className="data-cell">12.45 - 14</td>
                                    <td className="data-cell">12.30 - 13</td>
                                </tr>
                                <tr>
                                    <td className="data-cell">20.45 - 22</td>
                                    <td className="data-cell">20.45 - 22</td>
                                    <td className="data-cell">20.45 - 22</td>
                                    <td className="data-cell">20.45 - 22</td>
                                    <td className="data-cell">20.45 - 22</td>
                                    <td className="data-cell"></td>
                                    <td className="data-cell"></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NLAccordionOrari;
